import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { createFormData, sortObj } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import PackageListItem from '../components/packageListItem.js';
import Progress from '../components/progress.js';
import { Paginator } from '../components/paginator.js';
import Sort from '../components/sort.js';

function Packages() {
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('heading');
  const [sortOrder, setSortOrder] = useState(true);
  const [searchType, setSearchType] = useState('all');
  const [filteredItems, setFilteredItems] = useState([]);
  const [items, setItems] = useState([]);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [heading, setHeading] = useState('');
  const [identifier, setIdentifier] = useState('');
  
  let searchForm = useRef();
  let createForm = useRef();

  const updateHeading = (value) => {
    setHeading(value);
    value = value.toLowerCase().replaceAll(" ","-");
    setIdentifier(value);
  }

  const handleSearch = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let currentSearch = search;
    if(name === "search"){
      setSearch(value);
      currentSearch = value;
    }
    const filtered = [];
    for(let i = 0;i<items.length;i++){
      if(searchType === 'heading' && (currentSearch === undefined || currentSearch.trim() === '' || items[i].heading.indexOf(currentSearch) >= 0)){
        filtered.push(items[i]);
      } else if(searchType === 'identifier' && (currentSearch === undefined || currentSearch.trim() === '' || items[i].identifier.indexOf(currentSearch) >= 0)){
        filtered.push(items[i]);
      } else if(searchType === 'duration' && (currentSearch === undefined || currentSearch.trim() === '' || items[i].duration.indexOf(currentSearch) >= 0)){
        filtered.push(items[i]);
      } else if(searchType === 'destination' && (currentSearch === undefined || currentSearch.trim() === '' || items[i].destination.indexOf(currentSearch) >= 0)){
        filtered.push(items[i]);
      } else if(searchType === 'label' && (currentSearch === undefined || currentSearch.trim() === '' || items[i].label.indexOf(currentSearch) >= 0)){
        filtered.push(items[i]);
      } else if(searchType === 'all' && (currentSearch === undefined || currentSearch.trim() === '' || items[i].heading.indexOf(currentSearch) >= 0 || items[i].identifier.indexOf(currentSearch) >= 0 || items[i].duration.indexOf(currentSearch) >= 0 || items[i].destination.indexOf(currentSearch) >= 0 || items[i].label.indexOf(currentSearch) >= 0)){
        filtered.push(items[i]);
      }
    }
    setFilteredItems(sortObj(filtered, sortBy, sortOrder));
  }

  const updateSortParam = (e, field) => {
    let newSearchOrder = true;
    if(field === sortBy){
      newSearchOrder = !sortOrder;
    }else{
      setSortBy(field);
    }
    const sortList = filteredItems;
    setSortOrder(newSearchOrder);
    setFilteredItems(sortObj(sortList, field, newSearchOrder));
  }
  
  const resetSearch = (event) => {
    searchForm.current.reset();
    setSearch('');
    setSearchType('all');
    setFilteredItems(sortObj(items, sortBy, sortOrder));
  }
  
  const handleSubmit = (event) => {
    event.preventDefault();
    if(heading && identifier){
      setLoading(true);
      axios.post(global.config.api_server+'package',createFormData({
        heading: heading,
        identifier: identifier.toLowerCase().replaceAll(" ","-"),
        task:"create",
        token: localStorage.getItem("token")
      })).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('New package created');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
        }else{
          alertService.error(res.data.error);
        }
        setLoading(false);
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Fill required fields');
      setLoading(false);
    }
  }
  
  useEffect(()=>{
    let uri = global.config.api_server+'packages?token='+localStorage.getItem("token");
    axios.get(uri)
    .then(res => {
      if(res.status === 200 && res.data.status === "success"){
        const temp = res.data.packages;
        setItems(temp)
        setFilteredItems(sortObj(temp, sortBy, sortOrder));
        setLoading(false);
      }
    }).catch(err => {
      alertService.error(err);
    });
  }, []);
  
  const onPageChange = (index_start) => {
    setOffset(index_start);
  }

  let total = 0;
  let counter = 0;
  let offsetCounter = 0;
  const paginated_items = [];
  for (const u of filteredItems) {
    total++;
    offsetCounter++;
    if (offsetCounter > offset && counter < global.config.items_per_page){
      counter++;
      paginated_items.push(u);
    }
  }
  if(loading){
    return <Progress/>;
  }else{
    return(
      <div className="container-fluid">
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <a href="#" className={'btn btn-icon-split float-right btn-primary'} data-toggle="modal" data-target="#createPackageModal">
              <span className="icon text-white-50">
                <i className="fas fa-plane"></i>
              </span>
              <span className="text">Create New Package</span>
            </a>
            <form ref={searchForm} className="form-inline">
              <h6 className={'form-group mr-3 font-weight-bold text-primary'}>Packages</h6>
              <div className={"form-group mr-3"}>
                <select name="searchType" className="form-control" value={searchType} id="searchType" onChange={(e) => setSearchType(e.target.value)}>
                  <option value="all">All</option>
                  <option value="heading">Heading</option>
                  <option value="identifier">Identifier</option>
                  <option value="duration">Duration</option>
                  <option value="destination">Destination</option>
                  <option value="label">Label</option>
                </select>
              </div>
              <div className="form-group mr-3">
                <input type="search" name="search" className="form-control" placeholder="Search" onChange={handleSearch}/>
              </div>
              {search &&
              <div className="form-group mr-3">
                <a href="#" className="btn btn-default btn-icon-split" onClick={resetSearch}>
                  <span className="icon">
                    <i className="fas fa-times"></i>
                  </span>
                </a>
              </div>
              }
            </form>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <div className="row">
                <div className="col-sm-12">
                  <table className="table table-bordered" width="100%">
                    <thead>
                      <tr>
                        <th onClick={(e) => updateSortParam(e,'heading')}>Heading <Sort field="heading" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'identifier')}>Identifier <Sort field="identifier" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'duration')}>Duration <Sort field="duration" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'destination')}>Destination<Sort field="destination" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'label')}>Label<Sort field="label" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginated_items.map(item=>
                        <PackageListItem key={item.package_id} info={item}/>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <Paginator
                itemCount={total}
                itemsPerPage={global.config.items_per_page}
                showNextPages={2}
                showPrevPages={2}
                filterTotal={filteredItems.length}
                grandTotal={items.length}
                onClick={onPageChange.bind(this)}
              />
            </div>
          </div>
        </div>
        <div className="modal fade" id="createPackageModal" tabIndex="-1" role="dialog" aria-labelledby="create-popup" aria-hidden="true">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="create-plane">Create New Package</h5>
                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form ref={createForm}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Heading*</label>
                        <input type="text" value={heading} maxLength="100" name="heading" className="form-control" id="heading" placeholder="Enter Heading" onChange={(e) => updateHeading(e.target.value)}/>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Identifier* <small>( Do not use space )</small></label>
                        <input type="text" value={identifier} maxLength="100" name="identifier" className="form-control" id="identifier" placeholder="Enter Identifier" onChange={(e) => setIdentifier(e.target.value)}/>
                      </div>
                    </div>
                  </div>
                  {loading === true ? (
                    <Progress label='Creating..' small={true}/>
                  ):null}
                </div>
                <div className="modal-footer">
                  <button className="btn btn-default" type="reset" data-dismiss="modal">Close</button>
                  <button className={'btn btn-primary'} type="button" onClick={handleSubmit}>Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Packages;